<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :disabled="disabled"
    :class="$style.container"
    :style="style.container"
  >
    <div :style="style.innerContainer">
      <i
        :disabled="disabled"
        class="material-icons"
        :class="$style.italic"
        :style="style.italic"
      >
        {{ content }}
      </i>
    </div>
  </div>
</template>

<script>
  import { CssStyleProcessor } from '@js/vue-style-utils'

  export default {
    name: 'BaseGoogleMaterialIcon',
    inheritAttrs: false,
    props: {
      color: { type: [Object, String], required: false, default: null },
      content: { type: [Object, String], required: false, default: null },
      disabled: { type: Boolean, required: false, default: false },
      fontSize: { type: String, required: false, default: '12px' },
      styleConfig: { type: Object, required: false, default: () => {} },
    },
    data: function () {
      return {
        style: {
          container: {
            display: 'inline-block',
          },
          innerContainer: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          },
          italic: {
            display: 'block',
            userSelect: 'none',
          },
        },
      };
    },
    created: function () {
      const proc = new CssStyleProcessor('--v2-base-google-material-icon');

      Object.assign(
        this.style.container,
        proc.getExtendedStyle(this.styleConfig.container, 'container'),
      );
      Object.assign(
        this.style.innerContainer,
        this.styleConfig.innerContainer,
      );
      Object.assign(
        this.style.italic,
        proc.getExtendedStyle(this.styleConfig.italic, 'italic'),
      );
    },
  };
</script>

<style lang="stylus" module>
  .container
    background-color var(--v2-base-google-material-icon-container-background-color)
    border var(--v2-base-google-material-icon-container-border)
    border-radius var(--v2-base-google-material-icon-container-border-radius)
    border-width var(--v2-base-google-material-icon-container-border-width)
    box-shadow var(--v2-base-google-material-icon-container-box-shadow)
    height var(--v2-base-google-material-icon-container-height)
    width var(--v2-base-google-material-icon-container-width)
    &:hover
      background-color var(--v2-base-google-material-icon-container-background-color-hover)
      border var(--v2-base-google-material-icon-container-border-hover)
      border-radius var(--v2-base-google-material-icon-container-border-radius-hover)
      border-width var(--v2-base-google-material-icon-container-border-width-hover)
      box-shadow var(--v2-base-google-material-icon-container-box-shadow-hover)
      height var(--v2-base-google-material-icon-container-height-hover)
      width var(--v2-base-google-material-icon-container-width-hover)
    &:active
      background-color var(--v2-base-google-material-icon-container-background-color-active)
      border var(--v2-base-google-material-icon-container-border-active)
      border-radius var(--v2-base-google-material-icon-container-border-radius-active)
      border-width var(--v2-base-google-material-icon-container-border-width-active)
      box-shadow var(--v2-base-google-material-icon-container-box-shadow-active)
      height var(--v2-base-google-material-icon-container-height-active)
      width var(--v2-base-google-material-icon-container-width-active)
    &[disabled]
      background-color var(--v2-base-google-material-icon-container-background-color-disabled)
      border var(--v2-base-google-material-icon-container-border-disabled)
      border-radius var(--v2-base-google-material-icon-container-border-radius-disabled)
      border-width var(--v2-base-google-material-icon-container-border-width-disabled)
      box-shadow var(--v2-base-google-material-icon-container-box-shadow-disabled)
      height var(--v2-base-google-material-icon-container-height-disabled)
      width var(--v2-base-google-material-icon-container-width-disabled)

  .italic
    color var(--v2-base-google-material-icon-italic-color)
    cursor var(--v2-base-google-material-icon-italic-cursor)
    font-size var(--v2-base-google-material-icon-italic-font-size)
    text-decoration var(--v2-base-google-material-icon-italic-text-decoration)
    &:hover
      color var(--v2-base-google-material-icon-italic-color-hover)
      cursor var(--v2-base-google-material-icon-italic-cursor-hover)
      font-size var(--v2-base-google-material-icon-italic-font-size-hover)
      text-decoration var(--v2-base-google-material-icon-italic-text-decoration-hover)
    &:active
      color var(--v2-base-google-material-icon-italic-color-active)
      cursor var(--v2-base-google-material-icon-italic-cursor-active)
      font-size var(--v2-base-google-material-icon-italic-font-size-active)
      text-decoration var(--v2-base-google-material-icon-italic-text-decoration-active)
    &[disabled]
      color var(--v2-base-google-material-icon-italic-color-disabled)
      cursor var(--v2-base-google-material-icon-italic-cursor-disabled)
      font-size var(--v2-base-google-material-icon-italic-font-size-disabled)
      text-decoration var(--v2-base-google-material-icon-italic-text-decoration-disabled)
</style>
